import { memo } from "react";
import { dateTimeFormat } from "@/lib/date-tools";

// notification 변경되지 않으면 리렌더링하지 않도록 메모이제이션
export const NotificationMessage = memo(
  ({
    notification,
    onClickMessage,
    locale = "en",
  }: {
    notification: any;
    onClickMessage: any;
    locale: string;
  }) => (
    <div
      className={`mb-2 p-3 rounded-lg ${
        notification.isRead
          ? "bg-muted hover:bg-muted/80"
          : "bg-blue-100 dark:bg-blue-900/30 hover:bg-blue-200 dark:hover:bg-blue-900/50"
      } transition-colors duration-200 cursor-pointer`}
      onClick={() => onClickMessage(notification)}
    >
      <h3
        className={`font-bold ${notification.isRead ? "text-foreground" : "text-blue-700 dark:text-blue-300"}`}
      >
        {notification.title}
      </h3>
      <p
        className={`text-sm ${notification.isRead ? "text-foreground/80" : "text-foreground/90"}`}
      >
        {notification.body}
      </p>
      <p className="text-xs text-muted-foreground mt-1">
        {dateTimeFormat(
          notification.createdAt,
          locale === "ko" ? "ko-KR" : "en-US",
        )}
      </p>
    </div>
  ),
);

NotificationMessage.displayName = "NotificationMessage";
